export const HAS_SMOKING_PLACES_OPTIONS = [
    { id: 1, nombre: 'SI', value: 'SI' },
    { id: 2, nombre: 'NO', value: 'NO' },
    { id: 3, nombre: 'NC', value: 'NC' },
];
export const IS_SMOKING_ALLOWED_OPTIONS = [
    { id: 1, nombre: 'SI', value: 'SI' },
    { id: 2, nombre: 'NO', value: 'NO' }
];
